import {toggleSpinner, showToast} from "../global/utilities";

const paymentPage = document.querySelector('.payment-page');

if (paymentPage) {
    console.log('payment page');
}
